import React from 'react';

import Icon from '../Icon/Icon';

const VivaceBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <g stroke='#00D1D2' className='icon-accent-stroke icon-accent-fill'>
                    <path d='m18.379 22.626 7.293-7.292M21.316 34.013l5.764-5.764' />
                </g>
                <g stroke='#272A33'>
                    <path d='M11.29 22.626 25.469 8.45M21.316 40.313 33.13 28.5M6.278 42.222 41.722 6.778' />
                </g>
            </g>
        </Icon>
    );
};

export default VivaceBlueIcon;
